import { styled } from '@mui/material/styles';
import { Box, Table, TableCell, TableContainer, TableRow, Typography, TextField } from '@mui/material';

export const PageWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#F8F9FA',
  minHeight: '100vh',
}));

export const MainContentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: theme.spacing(3),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const ContentHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const SectionTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 700,
  color: '#333',
});

export const SearchField = styled(TextField)({
  width: '320px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '36px',
    backgroundColor: '#fff',
    '& fieldset': {
      borderColor: '#E0E0E0',
    },
    '&:hover fieldset': {
      borderColor: '#5E8E7E',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#5E8E7E',
    },
  },
  '& .MuiInputBase-input': {
    padding: '8px 14px',
    fontSize: '13px',
  },
});

export const TableWrapper = styled(TableContainer)({
  borderRadius: '8px',
  overflow: 'hidden',
});

export const ContactTable = styled(Table)({
  minWidth: 650,
});

export const ContactTableRow = styled(TableRow)({
  cursor: 'pointer',
  '&:nth-of-type(even)': {
    backgroundColor: '#F9FBF9',
  },
  '&:hover': {
    backgroundColor: '#F0F5F2',
  },
});

export const ContactTableCell = styled(TableCell)({
  fontSize: '13px',
  padding: '16px',
  color: '#444',
  borderBottom: '1px solid #F0F0F0',
});

export const InfoItem = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

export const InfoLabel = styled(Typography)({
  fontSize: '12px',
  fontWeight: 700,
  color: '#5E8E7E',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  marginBottom: '4px',
});

export const InfoValue = styled(Typography)({
  fontSize: '14px',
  color: '#333',
  fontWeight: 500,
  lineHeight: 1.5,
});

export const MessageContainer = styled(Box)({
  backgroundColor: '#F9FAFB',
  padding: '16px',
  borderRadius: '8px',
  marginTop: '8px',
  border: '1px solid #E5E7EB',
});
